/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';  // Import `useNavigate` hook
import PropTypes from 'prop-types';
import './Header.css';
import '../../../styles/styles.css';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Avatar, IconButton } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';  // Use `useDispatch` instead of `connect`
import { useQuery, useLazyQuery } from '@apollo/client';

import ModulesMenu from './ModulesMenu';
import AlarmsStatus from './AlarmsStatus';
import AspectStatus from './AspectStatus';
import * as Q from '../../../constants/graphqlQueries';
import UserRoles from '../../../constants/userRoles';

import logo from '../../../assets/img/logo.png';
import CustomTextField from '../../components/Textfield/CustomTextField';

const getSupervisorInfoFromUser = (user) => ({
  SupervisorEmployeeId: user.UserId,
  SupervisorEmployeeData: `${user.LastName}, ${user.FirstName}`,
});

const refreshFrequency = 30000;
const SuccessStatusResponse = 'OK';

const Header = ({ logout, setImpersonateUserAsUser }) => {
  const [alertCounts, setAlertCounts] = useState([]);
  const [supervisorSelected, setSupervisorSelected] = useState();
  const [supervisors, setSupervisors] = useState([]);
  const [filteredSupervisors, setFilteredSupervisors] = useState(supervisors);
  const [filterSupervisors, setFilterSupervisors] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [supervisorDropdownSelected, setSupervisorDropdownSelected] = useState(false);
  const [employeeInitials, setEmployeeInitials] = useState('');
  
  const user = useSelector((state) => state.User);
  const selectedDateRangePicker = useSelector((state) => state.Alerts.selectedDateRangePicker);
  const { data: dataSupervisors, refetch: refetchSupervisors } = useQuery(Q.SUPERVISORS_GA_QUERY);
  const [getEmployeeNames, { data: dataEmployeeNames }] = useLazyQuery(Q.APP_EMPLOYEE_NAMES_QUERY);

  // React Router's `useNavigate` hook replaces `withRouter`
  const navigate = useNavigate();

  const handleClick = (event) => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  };

  const onSignOut = () => {
    logout();
    navigate('/login');  // Redirect after logout (or wherever you need)
  };

  const supervisorDropdownHandleClose = () => {
    setSupervisorDropdownSelected(!supervisorDropdownSelected);
  };

  const headerMenuHandleClose = () => {
    setAnchorEl(null);
  };

  const { data: scheduleAlertsCount, stopPolling: stopPollingScheduleAlerts } = useQuery(
    Q.COUNT_SCHEDULE_ALERT,
    {
      variables: {
        EmployeeId: parseInt(user.EmployeeId, 10),
        CustomInit: selectedDateRangePicker[0] || null,
        CustomEnd: selectedDateRangePicker[1] || null,
      },
      pollInterval: 4 * 60 * 1000,
    },
  );

  const getEmployeeInitials = (firstName, lastName) => {
    if (firstName && lastName) {
      return `${firstName.charAt(0)}.${lastName.charAt(0)}`;
    }
    return 'NA';
  };

  const onChangeSupervisor = async (event, _user) => {
    stopPollingScheduleAlerts();
    const userSupervisor = { ..._user, IsImpersonated: true };

    if (userSupervisor.SupervisorEmployeeId === user.UserId) {
      userSupervisor.IsImpersonated = false;
      const employeeInitials = getEmployeeInitials(user.FirstName, user.LastName);
      setEmployeeInitials(employeeInitials);
    } else {
      getEmployeeNames({
        variables: {
          EmployeeId: _user.SupervisorEmployeeId,
        },
      });
    }

    setImpersonateUserAsUser(userSupervisor);
    setAnchorEl(null);
    setSupervisorSelected(_user);
  };

  const handleSearchSupervisor = (supervisor) => setFilterSupervisors(supervisor);

  useEffect(() => {
    if (dataSupervisors) {
      if (dataSupervisors.supervisors) {
        const indexSupervisor = dataSupervisors.supervisors.findIndex(
          (e) => parseInt(e.SupervisorEmployeeId, 10) === user.UserId,
        );
        if (indexSupervisor < 0) {
          setSupervisors([getSupervisorInfoFromUser(user), ...dataSupervisors.supervisors]);
        } else {
          setSupervisors(dataSupervisors.supervisors);
        }
      }
    }
  }, [dataSupervisors]);

  useEffect(() => {
    if (supervisors && supervisors.length > 0 && !supervisorSelected) {
      setSupervisorSelected(
        supervisors.find((s) => parseInt(s.SupervisorEmployeeId, 10) === user.EmployeeId),
      );
    }
  }, [supervisors]);

  useEffect(() => {
    if (scheduleAlertsCount) {
      const alertCounts = {
        ...scheduleAlertsCount.countScheduleAlerts,
      };
      setAlertCounts(alertCounts);
    }
  }, [scheduleAlertsCount]);
      
  useEffect(() => {
    if (dataEmployeeNames) {
      const employeeInitials = getEmployeeInitials(
        dataEmployeeNames.searchEmployeeNamesById.FirstName,
        dataEmployeeNames.searchEmployeeNamesById.LastName,
      );
      setEmployeeInitials(employeeInitials);
    }
  }, [dataEmployeeNames]);

  useEffect(() => {
    if (user && !employeeInitials) {
      const employeeInitials = getEmployeeInitials(user.FirstName, user.LastName);
      setEmployeeInitials(employeeInitials);
    }
  }, [user]);

  useEffect(() => {
    if (filterSupervisors.trim() !== '') {
      setFilteredSupervisors(
        supervisors.filter((supervisor) =>
          supervisor.SupervisorEmployeeData
            .toUpperCase()
            .includes(filterSupervisors.toUpperCase()),
        ),
      );
    } else {
      setFilteredSupervisors(supervisors);
    }
  }, [filterSupervisors, supervisors]);

  setTimeout(() => {
    refetchSupervisors();
  }, refreshFrequency);

  return (
    <>
      <div className='Header'>
        <div className='nav has-shadow'>
          <div className='container'>
            <div className='nav-left'>
              <Link to='/Landing'>
                <div className='nav-brand'>
                  <div className='l-item-brand-vline' />
                  <img className='l-item-brand' alt='' src={logo} />
                  <p className='l-item-brand-title'>
                    Workforce Management
                    <i className='l-item-brand-title-sufix-highlighted'>Automation</i>
                  </p>
                </div>
              </Link>
            </div>
            <div className='aspectHealthGroup'>
              <span className='aspectHealthTitle'>Aspect Health</span>
              <AspectStatus StatusResponse={SuccessStatusResponse} />
              <AlarmsStatus StatusResponse={SuccessStatusResponse} />
            </div>
            <div className='nav-right is-active'>
              <IconButton
                onClick={handleClick}
                size='small'
                sx={{ ml: 2 }}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
              >
                <Avatar className='r-item-user' sx={{ width: 32, height: 32 }}>
                  {employeeInitials}
                </Avatar>
              </IconButton>
              <Menu
                id='dropdown-header-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={headerMenuHandleClose}
              >
                <Tooltip
                  placement='left'
                  title={`Employee ID: ${user.IsImpersonated ? user.EmployeeId : user.UserId}`}
                >
                  <MenuItem className='logged-in-as-menu-item'>
                    Logged in as: <br /> {user.IsImpersonated ? user.EmailAddress : `${user.LastName}, ${user.FirstName}`}
                  </MenuItem>
                </Tooltip>
                {user.Role === UserRoles.Admin || user.Role === UserRoles.Owner || user.Role === UserRoles.WFM ? (
                  <>
                    <MenuItem
                      key={`${supervisorSelected} dropdown`}
                      className='supervisor-dropdown'
                      onClick={supervisorDropdownHandleClose}
                    >
                      Change to: {!supervisorDropdownSelected ? <ArrowDropDownIcon className='dropdown-caret' /> : <ArrowDropUpIcon className='dropdown-caret' />}
                    </MenuItem>
                    <Paper
                      key={`${supervisorSelected} content`}
                      className={`supervisor-dropdown-content ${supervisorDropdownSelected ? `active` : `disable`}`}
                    >
                      <div aria-hidden="true" style={{ padding: '0 16px 0 16px' }} onKeyDown={(e) => e.stopPropagation()}>
                        <CustomTextField
                          value={filterSupervisors}
                          handleChange={handleSearchSupervisor}
                          placeholder='Search'
                          inputIcon
                          width='100%'
                        />
                      </div>
                      {filteredSupervisors.length ? (
                        <List>
                          {filteredSupervisors.map((supervisor) => (
                            <ListItem
                              button
                              selected={supervisor === supervisorSelected}
                              onClick={(event) => onChangeSupervisor(event, supervisor)}
                              key={supervisor.SupervisorEmployeeId}
                            >
                              <ListItemText primary={supervisor.SupervisorEmployeeData} />
                            </ListItem>
                          ))}
                        </List>
                      ) : (
                        <span className='supervisor-empty-results'>No supervisors found</span>
                      )}
                    </Paper>
                  </>
                ) : null}
                <MenuItem onClick={onSignOut}>Log out</MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </div>
      <ModulesMenu />
    </>
  );
};

Header.propTypes = {
  logout: PropTypes.func.isRequired,
  setAlertCounts: PropTypes.func.isRequired,
  setImpersonateUserAsUser: PropTypes.func.isRequired,
};

export default Header;
